/**
 * Alert message resource
 *
 * @name Alert
 * @class
 * @augments TmrResource
 */
export const factory = [
  'Alert',
  /*@ngInject*/ (
    tmrAlertLevels,
    tmrAlertTargets,
    tmrLanguages,
    TmrApi,
    TmrLanguage,
    TmrResource,
    Place,
    Role
  ) => {
    let actions = {
      /**
       * Loads active alerts for the current user
       *
       * @method Alert#current
       */
      current: {
        method: 'GET',
        url: TmrApi.endpoint('Alert.current'),
        isArray: true,
        params: { target: 'WEB_APP' },
      },
    }
    let referencedProperties = [
      { property: 'places', resource: Place },
      { property: 'roles', resource: Role },
    ]
    let defaultValues = () => ({
      message: '{}',
      roles: [],
      places: [],
    })
    let Alert = TmrResource(
      'Alert',
      actions,
      referencedProperties,
      defaultValues
    )

    /**
     * Returns the alert message in the specified locale.
     * If no locale is specified, the message in the current language is returned,
     * with fallback on the current language
     */
    Alert.prototype.$getMessage = function (langcode) {
      let messages = JSON.parse(this.message)

      if (langcode === undefined) {
        langcode = TmrLanguage.current()
        return messages[langcode]
          ? messages[langcode]
          : messages[tmrLanguages.default]
      }

      return messages[langcode]
    }

    /** Sets the alert message in the specified locale. */
    Alert.prototype.$setMessage = function (message, langcode) {
      let messages = JSON.parse(this.message)
      messages[langcode] = message
      this.message = JSON.stringify(messages)
    }

    /** Returns the alert priority level */
    Alert.prototype.$getLevel = function () {
      return tmrAlertLevels[this.level]
    }

    /** Returns the alert device target */
    Alert.prototype.$getTarget = function () {
      return tmrAlertTargets[this.target]
    }

    return Alert
  },
]
